import { InputProps, Stack, StackProps } from "@chakra-ui/react";
import { SearchItem, useSearch } from "../hooks";
import { SearchSuggestion, SearchSuggestionProps } from "../search-suggestion";
import { Input } from "./input";

export interface LocationSearchProps extends StackProps {
  inputProps?: InputProps;
  searchSuggestionProps?: SearchSuggestionProps;

  fetcher: (input: string) => Promise<SearchItem[]>;
  onSuggestionSelected: (item: SearchItem) => void;
}

export const LocationSearch = ({
  children,
  fetcher,
  inputProps,
  searchSuggestionProps,
  onSuggestionSelected,
  ...rest
}: LocationSearchProps) => {
  const {
    items,
    input,
    selectedItem,
    onKeyDown,
    eventRef,
    menuNodes,
    handleSelection,
    setSelectedItem,
    setInput,
  } = useSearch(fetcher, onSuggestionSelected);
  return (
    <Stack {...rest}>
      <Input
        placeholder="Enter zip code, city, or address"
        aria-autocomplete="list"
        autoComplete="off"
        autoCorrect="off"
        spellCheck="false"
        size="lg"
        maxLength={64}
        _placeholder={{ color: "blueGray.500" }}
        aria-label="Search: Suggestions appear below"
        value={input}
        focusBorderColor="pink.400"
        bg="white"
        {...inputProps}
        borderRadius="md"
        borderBottomRadius={items.length > 0 ? 0 : "md"}
        borderColor="transparent"
        onKeyDown={onKeyDown}
        onChange={(e) => setInput(e.target.value)}
        {...rest}
      />

      {items &&
        items.map((x: SearchItem, index: number) => (
          <SearchSuggestion
            ref={menuNodes.ref(index)}
            key={x.label + " " + index}
            aria-selected={selectedItem === index ? true : undefined}
            bg="white"
            borderRadius="md"
            cursor="pointer"
            py="4"
            {...searchSuggestionProps}
            onMouseEnter={() => {
              setSelectedItem(index);
              // @ts-ignore
              eventRef.current = "mouse";
            }}
            onClick={() => handleSelection(index)}
            label={x.label}
          />
        ))}
    </Stack>
  );
};
